<template>
  <div class="header-main-menu-component hmmc container">
    <div class="row no-gutters hmmc__row">
      <div class="col col-12 col-sm-12 h-100">
        <b-container class="h-100 mw-100 hmmc__row-container">
          <b-row class="h-100 hmmc__row">
            <b-col class="hmmc__home-link-wrapper col-12 col-sm-2">
              <router-link to="/" class="hmmc__link hmmc__menu-item block-100">
                <span class="block-100 hmmc__mega-menu-title">{{ getContentItem("homeButton") }}</span>
              </router-link>
            </b-col>
            <!-- Parts Catalog -->
            <b-col class="hmmc__button-dropdown col-12 col-sm-2">
              <router-link
                id="HeaderMainMenuCatalog"
                class="hmmc__dropdown-toggle hmmc__link block-100"
                data-display="static"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                to="/Catalog/Index"
                @mouseover.native='PartsCatalogLinkIsBeingHovered = true;ShowPartsCatalogMenu();'
                @mouseleave.native='PartsCatalogLinkIsBeingHovered = false;HidePartsCatalogMenu();'
              >
                <div class="block-100">
                  <span class="hmmc__mega-menu-title">Parts Catalog</span>
                  <fa-icon icon="caret-down" class="hmmc__dropdown-caret"/>
                </div>
              </router-link>
              <div
                v-show="PartsCatalogMenuIsVisible"
                @mouseover="PartCatalogMenuIsBeingHovered = true;"
                @mouseleave="PartCatalogMenuIsBeingHovered = false;HidePartsCatalogMenu();"
                class="hmmc__dropdown-menu hmmc__catalog-menu p-0"
                aria-labelledby="HeaderMainMenuCatalog"
              >
                <catalog-nav class="w-100"/>
              </div>
            </b-col>
            <!-- Orders -->
            <b-col class="hmmc__button-dropdown hmmc__orders col-12 col-sm-2">
              <router-link
                id="hmmc__orders-menuLink"
                class="hmmc__dropdown-toggle hmmc__link hmmc__menu-item block-100"
                :to="{name: 'Orders' }"
                data-display="static"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                @click="clickEvent('/orders')"
                @mouseover.native='OrdersLinkIsBeingHovered = true;ShowOrdersMenu();'
                @mouseleave.native='OrdersLinkIsBeingHovered = false;HideOrdersMenu();'
              >
                <div class="block-100">
                  <span class="hmmc__mega-menu-title">{{ getContentItem("ordersButton") }}</span>
                  <fa-icon icon="caret-down" class="hmmc__dropdown-caret" />
                  <loading-spinner v-if="IsPartStoreOrderCountLoading()" class="hmmc__orders-menu--part-store-spinner"></loading-spinner>
                  <div v-else-if="IsNotNullOrUndefined(partStoreOrderTotal) && partStoreOrderTotal !== 0 && hasPermission('IsNGaugeOrderAdmin')" class="hmmc__orders-menu--part-store-count">{{ partStoreOrderTotal }}</div>
                </div>
              </router-link>
              <div class="hmmc__dropdown-menu hmmc__orders-menu"
                v-show="OrdersMenuIsVisible"
                @mouseover="OrdersMenuIsBeingHovered = true;"
                @mouseleave="OrdersMenuIsBeingHovered = false; HideOrdersMenu();"
                aria-labelledby="hmmc__orders-menuLink"
                >
                <ul class="hmmc__ul py-2 mb-0">
                  <li v-if="hasPermission('CanSeeOrders') && IsOrdersQuickOrdersSectionEnabled">
                    <a class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link text-left" href="/orders/quickorders">
                      {{ getContentItem("placeOrderDropDownButton")
                      }}
                    </a>
                  </li>
                  <li v-if="hasPermission('CanSeeOrders') && IsOrdersOpenOrdersSectionEnabled">
                    <router-link
                      :to="{ name: 'Orders' }"
                      class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link text-left"
                    >
                      {{ getContentItem("ordersDropDownButton") }}
                    </router-link>
                  </li>
                  <li v-if="hasPermission('CanSeeOrders') && IsOrdersBackOrdersSectionEnabled">
                    <dn-router-link
                      :title="getContentItem(&quot;backordersButton&quot;)"
                      url="/orders/backorders"
                      class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link text-left"
                    />
                  </li>
                  <li v-if="hasPermission('CanSeeOrders') && !hasPermission('CannotViewInvoices') && IsOrdersInvoicesSectionEnabled">
                    <dn-router-link
                      :title="getContentItem('invoicesButton')"
                      url="/orders/invoices"
                      class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link text-left"
                    />
                  </li>
                  <li v-if="IsOrdersCreditsSectionEnabled">
                    <router-link
                      class="hmmc__dropdown-item hmmc__link hmmc__menu-item hmmc__button-dropdown-link text-left"
                      :to="{ name: 'Credits' }"
                    >
                      {{ getContentItem("creditsButton") }}
                    </router-link>
                  </li>
                  <li v-if="IsPartsStoreOrdersSectionEnabled && hasPermission('IsNGaugeOrderAdmin')">
                    <router-link to="/partsStore/Orders/Index" id="orders-menu-parts-store" class="hmmc__dropdown-item hmmc__link hmmc__menu-item hmmc__button-dropdown-link text-left">
                      Parts Store Orders 
                      <loading-spinner v-if="IsPartStoreOrderCountLoading()"></loading-spinner>
                      <div v-else-if="IsNotNullOrUndefined(partStoreOrderTotal) && partStoreOrderTotal !== 0" class="hmmc__order-submenu--part-store-count">
                        {{ partStoreOrderTotal }}
                      </div>
                    </router-link>
                  </li>
                </ul>
              </div>
            </b-col>
            <!-- Claims and Returns -->
            <b-col class="hmmc__button-dropdown col-12 col-sm-2">
              <router-link
                id="claimsMenuLink"
                class="hmmc__dropdown-toggle hmmc__link hmmc__menu-item block-100"
                data-display="static"
                role="button"
                aria-haspopup="true"
                aria-expanded="false"
                @mouseover.native='ClaimsLinkIsBeingHovered = true;ShowClaimsMenu();'
                @mouseleave.native='ClaimsLinkIsBeingHovered = false;HideClaimsMenu();'
                to="/claimsAndReturns/index"
              >
               <div class="block-100">
                 <span class="hmmc__mega-menu-title">Claims and Returns</span>
                 <fa-icon icon="caret-down" class="hmmc__dropdown-caret"/>
               </div>
              </router-link>
              <div
                class="hmmc__dropdown-menu hmmc__claims-menu"
                aria-labelledby="claimsMenuLink"
                v-show="ClaimsMenuIsVisible && (hasPermission('CanSubmitDiscrepancyClaims') || hasPermission('CanViewReturns'))"
                @mouseover="ClaimsMenuIsBeingHovered = true;"
                @mouseleave="ClaimsMenuIsBeingHovered = false;HideClaimsMenu();"
              >
                <div class="hmmc__claims-container">
                  <b-row class="w-100 no-gutters px-2">
                    <b-col class="col-sm-4 hmmc__claims" v-if="hasPermission('CanSubmitDiscrepancyClaims') || hasPermission('CanViewReturns')" >
                      <h3>Claims</h3>
                      <p class="hmmc__claims-text">
                        A parts shipment claim allows you to notify DealerNet that an error was made in picking, 
                        packaging, shipping or invoicing a Sales Order, as a result of some action by DealerNet, 
                        a Logisnext/Promatch technical quote or printed literature.
                      </p>
                      <ul class="hmmc__ul hmmc__claims-ul">
                        <li v-if="hasPermission('CanSubmitDiscrepancyClaims')" class="hmmc__claims-li">
                          <CreateClaimLink class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link" />
                        </li>
                        <li v-if="hasPermission('CanViewReturns')" class="hmmc__claims-li">
                          <router-link to="/claimsAndReturns/claims" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            View Claims
                          </router-link>
                        </li>
                      </ul>
                    </b-col>
                    <b-col v-if="hasPermission('CanViewReturns')" class="col-sm-4 hmmc__claims px-2">
                      <h3>Returns</h3>
                      <p class="hmmc__claims-text">
                        A parts return allows you to notify DealerNet that a part was ordered in surplus, as a result of
                        some action by you (the dealer), not DealerNet.
                      </p>
                      <ul class="hmmc__ul hmmc__claims-ul">
                        <li v-if="IsReturnsCreateSectionEnabled && (hasPermission('CanSubmitExpressReturns') || hasPermission('CanSubmitAnnualReturns'))" class="hmmc__claims-li">
                          <router-link to="/ClaimsAndReturns/CreateReturn?returnId=0" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            Start Return
                          </router-link>
                        </li>
                        <li v-if="IsReturnsSectionEnabled" class="hmmc__claims-li">
                          <router-link to="/claimsAndReturns/returns" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            View Returns
                          </router-link>
                        </li>
                      </ul>
                    </b-col>
                    <b-col v-if="hasPermission('CanSubmitDiscrepancyClaims') || hasPermission('CanViewCCR')" class="col-sm-4 hmmc__claims hmmc__claims-last pl-2">
                      <h3>Entitlements</h3>
                      <p class="hmmc__claims-text">
                        Entitlements are what allow you to return a core resulting from the sale of a remanufactured
                        product for credit. Choose the entitlements for the cores you will be returning when you submit a
                        Core Credit Request on DealerNet.
                      </p>
                      <ul v-if="IsEntitlementsSectionEnabled" class="hmmc__ul hmmc__claims-ul">
                        <li v-if="hasPermission('CanSubmitCCR')" class="hmmc__claims-li">
                          <router-link :to="{name: 'Entitlements'}" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            Start a Core Credit Request
                          </router-link>
                        </li>
                        <li class="hmmc__claims-li">
                          <router-link :to="{name: 'OpenCoreCreditRequests'}" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            View Open CCRs
                          </router-link>
                        </li>
                        <li class="hmmc__claims-li" >
                          <router-link :to="{name: 'CoreCredits'}" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            View Core Credits
                          </router-link>
                        </li>
                        <li v-if="hasPermission('CanSubmitCCR')" class="hmmc__claims-li">
                          <router-link :to="{name: 'CorePurchaseRequest'}" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            Start a Core Purchase Request
                          </router-link>
                        </li>
                        <li class="hmmc__claims-li">
                          <router-link :to="{name: 'Entitlements', query: {showExpiredOnly: true}}" class="hmmc__link hmmc__menu-item hmmc__button-dropdown-link">
                            Expired Entitlements
                          </router-link>
                        </li>
                      </ul>
                    </b-col>
                  </b-row>
                  <b-row class="hmmc__view-all-claims no-gutters justify-content-end">
                    <router-link to="/claimsAndReturns/index" class="hmmc__view-all-claims-link hmmc__menu-item">
                      All Claims &amp; Returns
                      <b>&gt;</b>
                    </router-link>
                  </b-row>
                </div>
              </div>
            </b-col>
            <b-col v-if="canPlaceOrders || canViewQuickOrder" class="hmmc__quickorder col-sm-3">
              <router-link :to="{name: 'QuickOrders'}" id="quickOrder">
                <div class="hmmc__quickorder">
                  {{ getContentItem("quickOrderButton") }}
                </div>
              </router-link>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from "vuex"
  import { controlsHelper } from "@/components/mixins/commonControlsHelper"
  import { CatalogService } from "@/services/CatalogService"
  import { themeHelper } from "@/components/mixins/themeHelper"
  import { ErrorLogService } from "@/services/ErrorLogService"
  import { siteSectionsHelper } from "@/components/mixins/siteSectionsHelper"
  import CreateClaimLink from "@/components/Elements/CreateClaimLink"
  import CatalogNav from "@/components/Catalog/MegaMenu/CatalogNav"
  import { DnRouterLink } from "@/components/Elements"
  import { PartsStoreOrdersService } from "@/services/PartsStoreOrdersService"
  import { LoadingSpinner } from "@/components"
  import { OrderStatus } from "@/types";

  export default {
    components: {
      CreateClaimLink,
      CatalogNav,
      DnRouterLink,
      LoadingSpinner
    },
    mixins: [ 
      LoadingSpinner, 
      controlsHelper, 
      themeHelper, 
      siteSectionsHelper, 
    ],
    data: function() {
      return {
        catalogItems: [],
        currentCatalogItems: [],
        currentSeeAlsoItems: [],
        currentRelatedDocuments: [],

        OrdersLinkIsBeingHovered: false,
        PartsCatalogLinkIsBeingHovered: false,
        ClaimsLinkIsBeingHovered: false,

        OrdersMenuIsVisible: false,
        PartsCatalogMenuIsVisible: false,
        ClaimsMenuIsVisible: false,

        OrdersMenuIsBeingHovered: false,
        PartCatalogMenuIsBeingHovered: false,
        ClaimsMenuIsBeingHovered: false,
      }
    },
    computed: {
      ...mapGetters([
        "getContentItem", 
        "IsMcfa", 
        "IsMcfe", 
        "hasPermission",
        "canPlaceOrders",
        "canViewQuickOrder",
        "activeAccountId",
        "McfCostCenterId",
        "user",
        "activeAccountId",
        "isUserUpdating",
        "partStoreOrderTotal"
      ])
    },
    mounted(){
    },
    methods: {
      ShowPartsCatalogMenu: function(){
        var self = this;
        setTimeout(function(){
            if(self.PartsCatalogLinkIsBeingHovered){
              self.PartsCatalogMenuIsVisible = true;
              self.AddMegaMenuEventListeners();
            }
        },200);
      },
      HidePartsCatalogMenu: function(){
        var self = this;
        setTimeout(function(){
          if(!self.PartCatalogMenuIsBeingHovered && !self.PartsCatalogLinkIsBeingHovered){
            self.PartsCatalogMenuIsVisible = false;
          }
        },200);
      },
      ShowOrdersMenu: function(){
        var self = this;
        setTimeout(function(){
          if(self.OrdersLinkIsBeingHovered){
            self.OrdersMenuIsVisible = true;
            self.AddMegaMenuEventListeners();
          }
        },200);
      },
      HideOrdersMenu: function(){
        var self = this;
        setTimeout(function(){
          if(!self.OrdersMenuIsBeingHovered && !self.OrdersLinkIsBeingHovered){
            self.OrdersMenuIsVisible = false;
          }
        },200);
      },
      ShowClaimsMenu: function(){
        var self = this;
        setTimeout(function(){
          if(self.ClaimsLinkIsBeingHovered){
            self.ClaimsMenuIsVisible = true;
            self.AddMegaMenuEventListeners();
          }
        },200);
      },
      HideClaimsMenu: function(){
        var self = this;
        setTimeout(function(){
          if(!self.ClaimsMenuIsBeingHovered && !self.ClaimsLinkIsBeingHovered){
            self.ClaimsMenuIsVisible = false;
          }
        },200);
      },
      IsPartStoreOrderCountLoading: function(){
        let isLoading = this.isUserUpdating || this.IsNullOrUndefined(this.partStoreOrderTotal)
        return isLoading
      },
      AddMegaMenuEventListeners(){
        // Add the class 'hmmc__menu-item' to any element(s) that should auto close the mega menu on click
        const megaMenuLinks = document.querySelectorAll('.hmmc__menu-item');

        for(var i = 0; i < megaMenuLinks.length; i++){
          var megaMenuLink = megaMenuLinks[i];
          megaMenuLink.addEventListener("click", event => {
            this.HideMegaMenuDropdowns();
          })
        }
      },
      HideMegaMenuDropdowns(){
        let dropdownMenus = document.getElementsByClassName("hmmc__dropdown-menu");
        for(let i = 0; i < dropdownMenus.length; i++){
          dropdownMenus[i].style.display = 'none';
        }        
      }
    }
  }
</script>

<style lang="scss">
.hmmc__orders-menu--part-store-spinner{
  width: 2rem;
  height: 2rem;
  margin: 15px;
  float: right;
}

.hmmc__orders-menu--part-store-count{
  
    background-color: #761949;
    color: white;
    width: 2rem;
    height: 2rem;
    display: flex;
    flex-shrink: 0;
    font-size: 1rem;
    border-radius: 50%;
    margin: .5rem 0rem .5rem 2rem;
    align-items: center;
    justify-content: center;
    border: 1px solid #f4f4f4;
    box-shadow: 0.25rem 0.25rem 0.5rem rgba(0, 0, 0, 0.25);
    box-sizing: inherit;
    font-weight: bold;
    pointer-events: none;
    user-select: none;
    float: left;
}

#orders-menu-parts-store{
    padding-right: 0px;
}

.hmmc__order-submenu--part-store-count{
    background-color: #761949;
    color: white;
    width: 1.75rem;
    height: 1.25rem;
    display: flex;
    flex-shrink: 0;
    font-size: .75rem;
    border-radius: 50%;
    margin: 0px;
    align-items: center;
    justify-content: center;
    border: 1px solid #f4f4f4;
    box-shadow: 0.25rem 0.25rem 0.5rem rgba(0, 0, 0, 0.25);
    box-sizing: inherit;
    font-weight: bold;
    pointer-events: none;
    user-select: none;
    float: right;
}

.hmmc__quickorder {
  cursor: pointer;
  display: block;
  height: 100%;
  width: 100%;
  float: right;
  line-height: 34px;
  text-align: center;
  padding: 3px;
  background: #f8bc16;
  font-size: 16px;
  font-weight: bold;
}

.hmmc__row{
  height: 100%;
}

.hmmc__row.row{
  width: 104.5%;
}

.header-main-menu-component{
  border: 1px solid #797979;
  border-radius: 2px;
  margin-top: -30px;
  list-style-type: none;
  padding: 0;
  height: 48px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25), inset 0 -1px 0 rgba(0, 0, 0, 0.1);
  background-color: #f4f4f4; // Fallback for Safari
  background: -webkit-linear-gradient(top, #f4f4f4, #e7ebf4); // Safari prefix
  background: linear-gradient(to bottom, #f4f4f4, #e7ebf4);
  z-index: 100;
}

.hmmc__button-dropdown {
  border-right: 2px groove #e3e3e3;
  font-family: Calibri, Tahoma, Arial, Helvetica, sans-serif;
  font-size: 21px;
  height: 100%;
  line-height: 48px;
}

.hmmc__claims-menu .show {
  background: #b6b9c0 linear-gradient(to bottom, #e0e0e0 6%, #dfe3ec 6%, #b6b9c0 100%) repeat-x;
}

.hmmc__dropdown-menu {
  background: #fff;
  border: 1px solid #c0bfbf;
  outline: solid 4px #e7e7e7;
  width: 848px;
  height: 510px;
  margin-top: 7px;
}



.hmmc__orders-menu {
  width: 150px;
  height: auto;
  background-color: whitesmoke;
  left: 0;
  text-align: left;
  position: relative;
  box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.75);
  z-index: 2;
}


.hmmc__link {
  color: #666;
  font-size: 19px;
  font-weight: 700;
  text-shadow: 0 1px 0 white;
  text-align: left;
  text-decoration: none;
  line-height: 48px;

  &:hover{
    color: #00010e;
    text-decoration: none;
  }
}


.hmmc__dropdown-caret{
  float: left;
  height: 100%;
  transform: translate(5px,1.2px);
}

.hmmc__home-link-wrapper {
  border-right: 2px groove #e3e3e3;
  margin-left: 15px;
}

.hmmc__ul {
  list-style-type: none;
  padding-left: 0%;
}

.hmmc__button-dropdown-link{
  color: #004990;
  display: block;
  line-height: 17px;
  font-family: arial, helvetica, sans-serif;
  font-size: 12px;
  text-align: left;
}

.hmmc__button-dropdown-link.text-left {
  padding: 4px 10px;
}

.hmmc__catalog-menu {
  height: auto;
  left: -78px;
  line-height: normal;
  z-index: 100;
  position: relative;
  box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.75);
}

.hmmc__button-dropdown-link{
  padding-left: 5px;
  &:hover{
    color: #fff;
    background-color: $brand;
    text-decoration: none;
  }
  &.active{
    color: #fff;
    background-color: $brand;
    text-decoration: none;
  }
}

.hmmc__claims-menu {
  left: -400px;
  height: 350px;
  z-index: 5;
  position: relative;
  box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.75);
}

.hmmc__claims{
  height: 290px;
  padding-bottom: 10px;
  background-color: #fff;
  padding-top: 12px;
  background-image: none;
  border-radius: 0;
  border-right: 1px solid #ddd;
}

.hmmc__claims-text{
  height: 100px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 13px;
  line-height: 18px;
}

.hmmc__claims-last{
  border-right: none;
}

.hmmc__claims-ul{
  font-size: 12px;
  margin-bottom: 0;
}
.hmmc__claims-li{
  height: 24px;
}

.hmmc__mega-menu-title{
  float: left;
  white-space: nowrap;
  font-size: 16px;
  font-weight: normal;

  @media (min-width: $screen-md-min){
   font-size:19px;
  }
}



.hmmc__view-all-claims {
  background-color: #f5f5f5;
  padding: 15px 25px 10px 0;
  height: 50px;
}

.hmmc__view-all-claims-link {
  font-size: 18px;
  line-height: 20px;
  color: $blue;
  &:hover{
    color: $brand;
    text-decoration: underline;
  }

  .hmmc__row-container{
    max-width: 100%;
  }
}
</style>
